import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { canAccessReport } from '../helper/authorizedUsers'

/** Klasik rapor path’leri için reportKey bayrağı kontrolü */
const ReportPermissionRoute = ({ reportKey }) => {
  const { currentUser } = useSelector((state) => state.auth)

  if (!currentUser) {
    return <Navigate to="/login" />
  }

  if (!canAccessReport(currentUser, reportKey)) {
    return <Navigate to="/access-denied" />
  }

  return <Outlet />
}

export default ReportPermissionRoute
